
import { usePresence as usePresenceContext } from '@/contexts/PresenceContext';

/**
 * A hook to access presence functionality.
 * This is a simple wrapper around the PresenceContext.
 * 
 * Components using this hook should manage their own lifecycle for tracking/untracking users.
 * 
 * Example usage:
 * ```tsx
 * const { trackUserPresence, untrackUserPresence, isUserOnline } = usePresence();
 * 
 * useEffect(() => {
 *   if (shouldTrack && userId) {
 *     trackUserPresence(userId);
 *     return () => untrackUserPresence(userId);
 *   }
 * }, [shouldTrack, userId, trackUserPresence, untrackUserPresence]);
 * ```
 */
export function usePresence() {
  return usePresenceContext();
}
